// bootstrap-spin - v1.0
// https://shaack.com/projekte/bootstrap-input-spinner/
!function(N){"use strict";function n(t,r){var o=t.locale||"en-US";this.parse=function(t){var e=new Intl.NumberFormat(o),n=e.format(11111).replace(/1/g,"")||".",e=e.format(1.1).replace(/1/g,"");return parseFloat(t.replace(new RegExp(" ","g"),"").replace(new RegExp("\\"+n,"g"),"").replace(new RegExp("\\"+e),"."))},this.render=function(t){var e=parseInt(r.getAttribute("data-decimals"))||0,n=!("false"===r.getAttribute("data-digit-grouping"));return new Intl.NumberFormat(o,{minimumFractionDigits:e,maximumFractionDigits:e,useGrouping:n}).format(t)}}var k=!1,r=N.fn.val;function F(t,e){t.addEventListener("mousedown",function(t){0===t.button&&(t.preventDefault(),e(t))}),t.addEventListener("touchstart",function(t){t.cancelable&&t.preventDefault(),e(t)}),t.addEventListener("keydown",function(t){32!==t.keyCode&&13!==t.keyCode||k||(k=!0,e(t))})}N.fn.val=function(t){var e;return 1<=arguments.length&&this[0]&&this[0]["bootstrap-input-spinner"]&&this[0].setValue&&(e=this[0],setTimeout(function(){e.setValue(t)})),r.apply(this,arguments)},N.fn.inputSpinner=function(t){if("destroy"===t)return this.each(function(){this.destroyInputSpinner()}),this;var e,C={decrementButton:"<strong>&minus;</strong>",incrementButton:"<strong>&plus;</strong>",groupClass:"",buttonsClass:"btn-outline-secondary",buttonsWidth:"2.5rem",textAlign:"center",autoDelay:500,autoInterval:50,buttonsOnly:!1,keyboardStepping:!0,locale:navigator.language,editor:n,template:'<div class="input-group ${groupClass}"><div class="input-group-prepend"><button style="min-width: ${buttonsWidth}" class="btn btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button></div><input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control form-control-text-input"/><div class="input-group-append"><button style="min-width: ${buttonsWidth}" class="btn btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button></div></div>'};for(e in t)C[e]=t[e];var $=C.template.replace(/\${groupClass}/g,C.groupClass).replace(/\${buttonsWidth}/g,C.buttonsWidth).replace(/\${buttonsClass}/g,C.buttonsClass).replace(/\${decrementButton}/g,C.decrementButton).replace(/\${incrementButton}/g,C.incrementButton).replace(/\${textAlign}/g,C.textAlign);return this.each(function(){var r=N(this);r[0]["bootstrap-input-spinner"]=!0,r.hide(),r[0].inputSpinnerEditor=new C.editor(C,this);var e=null,n=null,o=N($),i=o.find(".btn-decrement"),a=o.find(".btn-increment"),p=o.find("input"),u=N("label[for='"+r.attr("id")+"']");u[0]||(u=r.closest("label"));var s=null,l=null,d=null;E();var c=parseFloat(r[0].value),t=r.attr("data-prefix")||"",f=r.attr("data-suffix")||"";t&&(t=N('<span class="input-group-text">'+t+"</span>"),o.find(".input-group-prepend").append(t)),f&&(m=N('<span class="input-group-text">'+f+"</span>"),o.find(".input-group-append").prepend(m)),r[0].setValue=function(t){b(t)},r[0].destroyInputSpinner=function(){r.prop("required",p.prop("required")),v.disconnect(),w(),p.off("paste input change focusout"),o.remove(),r.show(),u[0]&&u.attr("for",r.attr("id"))};var m,g,v=new MutationObserver(function(){E(),b(c,!0)});function b(t,e){void 0===e&&(e=!0),c=isNaN(t)||""===t?(r[0].value="",e&&(p[0].value=""),NaN):(t=parseFloat(t),t=Math.min(Math.max(t,s),l),r[0].value=t,e&&(p[0].value=r[0].inputSpinnerEditor.render(t)),t)}function h(e,n){n&&setTimeout(function(){var t;"function"==typeof Event?t=new Event(n,{bubbles:!0}):(t=document.createEvent("Event")).initEvent(n,!0,!0),e[0].dispatchEvent(t)})}function y(t){x(t),w(),e=setTimeout(function(){n=setInterval(function(){x(t)},C.autoInterval)},C.autoDelay)}function x(t){isNaN(c)&&(c=0),b(Math.round(c/t)*t+t),h(r,"input"),h(r,"change")}function w(){clearTimeout(e),clearTimeout(n)}function E(){r.prop("required")&&(p.prop("required",r.prop("required")),r.removeAttr("required")),p.prop("placeholder",r.prop("placeholder")),p.attr("inputmode",r.attr("inputmode")||"decimal");var t=r.prop("disabled"),e=r.prop("readonly");p.prop("disabled",t),p.prop("readonly",e||C.buttonsOnly),a.prop("disabled",t||e),i.prop("disabled",t||e),(t||e)&&w();t=r.prop("class"),e="";/form-control-sm/g.test(t)?e="input-group-sm":/form-control-lg/g.test(t)&&(e="input-group-lg");t=t.replace(/form-control(-(sm|lg))?/g,"");o.prop("class","input-group "+e+" "+C.groupClass),p.prop("class","form-control "+t),s=isNaN(r.prop("min"))||""===r.prop("min")?-1/0:parseFloat(r.prop("min")),l=isNaN(r.prop("max"))||""===r.prop("max")?1/0:parseFloat(r.prop("max")),d=parseFloat(r.prop("step"))||1,r.attr("hidden")?o.attr("hidden",r.attr("hidden")):o.removeAttr("hidden"),r.attr("id")&&(p.attr("id",r.attr("id")+"_MP_cBdLN29i2"),u[0]&&u.attr("for",p.attr("id")))}v.observe(r[0],{attributes:!0}),r.after(o),b(c),p.on("paste input change focusout",function(t){var e=p[0].value,n="focusout"===t.type;b(e=r[0].inputSpinnerEditor.parse(e),n),h(r,t.type)}).on("keydown",function(t){C.keyboardStepping&&(38===t.which?(t.preventDefault(),i.prop("disabled")||y(d)):40===t.which&&(t.preventDefault(),a.prop("disabled")||y(-d)))}).on("keyup",function(t){!C.keyboardStepping||38!==t.which&&40!==t.which||(t.preventDefault(),w())}),F(i[0],function(){i.prop("disabled")||y(-d)}),F(a[0],function(){a.prop("disabled")||y(d)}),m=document.body,g=function(){w()},m.addEventListener("mouseup",function(t){g(t)}),m.addEventListener("touchend",function(t){g(t)}),m.addEventListener("keyup",function(t){32!==t.keyCode&&13!==t.keyCode||(k=!1,g(t))})}),this}}(jQuery);

!function (Helpers, $, undefined) {
  'use strict';
  
  let loadedScripts = new Array();
  
  Helpers.isVisible = function(el) {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while(el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    };

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  };
  
  Helpers.loadScript = function(script_to_load, callback){
    if(!loadedScripts.includes(script_to_load)){
      jQuery.getScript(script_to_load, function(){
        loadedScripts.push( script_to_load);
      }).done(function( script, textStatus ) {
        callback();
      });
    } else {
      callback();
    };
  };
  
  Helpers.getRechargeCheckoutUrl = function() {
    var token;
    do { token = Shopify.getCookie('cart'); } while (token == undefined);
    var myshopify_domain = Shopify.permanent_domain;
    try { var ga_linker = ga.getAll()[0].get('linkerParam'); } catch (err) { var ga_linker = ''; }
    var checkout_url = 'https://checkout.rechargeapps.com/r/checkout?myshopify_domain=' + myshopify_domain + '&cart_token=' + token + '&' + ga_linker;
    return checkout_url;
  };
         
  var bindUIActions = function () {
    
    jQuery('body :not(script)').contents().filter(function() {
      return this.nodeType === 3;
    }).replaceWith(function() {
      return this.nodeValue.replace(/[™®]/g, '<sup>$&</sup>');
    });
    
  };

  Helpers.init = function () {
    bindUIActions();
    
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    });
    
    if( parseInt(jQuery(window).width()) < 768 ) { 
      var toastElList = [].slice.call(document.querySelectorAll('.toast'))
      var toastList = toastElList.map(function (toastEl) {
        return new bootstrap.Toast(toastEl, { delay:7000 });
      });
    };
    
    /* Click Add-to-Cart on item */
    jQuery('[add-to-cart]').on('click', function (evt) {
      // if variant ID passed, use that
      evt.preventDefault();

      var product_id = jQuery(this).data('product-id');
      var variant_id = jQuery(this).data('variant-id');
      var quantity_to_add = 1;

      /* item is already in cart */
      if( jQuery(this).hasClass('active') ) {
        Shopify.removeItem( variant_id, function() {});
        /* item is NOT in cart */
      } else {
        Shopify.addItem( variant_id, quantity_to_add, function(item) {});
      } // if( jQuery(this).hasClass('active') )
    });
    
  };
  
}(window.Helpers = window.Helpers || {}, jQuery),
function (HomePage, $, undefined) {
  'use strict';
  
  HomePage.init = function () {
   
    if( parseInt(jQuery(window).width()) < 768 ) { 
     	var target_ele = jQuery('.content-grid.its-science .row .content .title');
        jQuery('.content-grid.its-science .content.header').append(target_ele);
    	
    };
    
    
  };
  
}(window.HomePage = window.HomePage || {}, jQuery),
function (Blog, $, undefined) {

  var bindUIActions = function () {

  };

  Blog.init = function () {
    bindUIActions();
  };

}(window.Blog = window.Blog || {}, jQuery),
function (Collections, $, undefined) {

  var bindUIActions = function () {
    
  };

  Collections.init = function () {
    bindUIActions();
  };

}(window.Collections = window.Collections || {}, jQuery),
function (Cart, $, undefined) {

  var bindUIActions = function () {
    
    jQuery('section.cart .order-list [quantity-select]').each(function( index ) {

      if(jQuery(this).next().length == 0) jQuery(this).inputSpinner();

      jQuery(this).on("change", function (event) {
        var variant_id = jQuery(this).closest('[quantity-select]').data('variant-id');
        var item_price = jQuery(this).closest('[quantity-select]').data('variant-price');
        var item_original_price = jQuery(this).closest('[quantity-select]').data('variant-original-price');
        var qty = jQuery(this).val();
        var target_ele = jQuery(this);
        var parent_ele =jQuery(this).parent().parent().parent();

        Shopify.changeItem( variant_id, qty, function() {
          /* update line item price */
          parent_ele.find('[item-price]').html( Shopify.formatMoney( (item_price*qty) ));
          if( item_original_price > item_price)
            parent_ele.find('[item-original-price]').html( Shopify.formatMoney( (item_original_price*qty) ));
        });
      });
    });

    /* Click Add-to-Cart on item */
    jQuery('[remove-from-cart]').on('click', function (evt) {
      // if variant ID passed, use that
      evt.preventDefault();
      Shopify.removeItem( jQuery(this).data('variant-id') );
    });
    
    jQuery('form[action="/cart"]').on('submit', function (evt) {
      evt.preventDefault();

      var has_subscription = ($(this).find('[data-is-subscription]').length)?true:false;
      
      if( has_subscription ) {
        var checkout_url = Helpers.getRechargeCheckoutUrl();
      } else {
        var checkout_url = Shopify.secure_url + '/checkout';
      }
      var discount_code = Shopify.getCookie('discount_code');
      if( discount_code ) checkout_url += '?discount='+discount_code;
      window.location = checkout_url;
      return false;
    });
    
  };
  
  Cart.init = function () {
    Shopify.runPromotions();
    bindUIActions();
  }; 

}(window.Cart = window.Cart || {}, jQuery);